import { FareFamilyOptionFragment } from '@websky/graphql';
import { useMemo } from 'react';
import { useFareOverrides } from './useFareOverrides';
import { FareGroupOption, FareGroupVariant } from './types';
import { getFareOptionTooltipTitle, getOptionTitle } from '../lib/utils';
import { getUniqueValidOptions } from '../../../../Results/utils';

export const useFareOptions = (
	options: FareFamilyOptionFragment[],
	variant: FareGroupVariant,
	showUnavailableOptions: boolean
) => {
	const { renderFeaturePaymentTypeIcon, renderFareOptionsTypeIcon } = useFareOverrides();

	const [gridOptions, listOptions] = useMemo(() => {
		const filteredOptions = getUniqueValidOptions(options, false, false, showUnavailableOptions);

		const grid: FareGroupOption[] = [];
		const list: FareGroupOption[] = [];

		filteredOptions.forEach(({ isKeyOption, title, shortDescription, value, size, type, availability }) => {
			const option = {
				title: getOptionTitle({
					title,
					value,
					size,
					isKeyOption,
					variant
				}),
				paymentType: availability,
				optionType: type,
				paymentIcon: renderFeaturePaymentTypeIcon(availability),
				optionIcon: renderFareOptionsTypeIcon(type),
				tooltip: getFareOptionTooltipTitle(title, shortDescription)
			};

			if (isKeyOption) {
				/** Для variant === 'small', ключевые опции выводим в плитке */
				grid.push(option);
			} else {
				/** Для variant === 'small', остальные опции выводим в списке */
				list.push(option);
			}
		});

		/** Для variant === 'big' выводим все опции в плитке */
		return [variant === 'big' ? [...grid, ...list] : grid, list];
	}, [options, variant, showUnavailableOptions]);

	return { gridOptions, listOptions };
};
